<template>
  <div>
    <!-- ヘッダ -->
    <comVFHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username"></comVFHeaderAuth>
  </div>
</template>
<script>
export default {
  name: "VFHomePage",
  data() {
    return {
      screenTitle: "ホーム",
      screenId: "PSC100",
    };
  },
}
</script>
<style scoped>

</style>
